<template lang="pug">
  #Footer
    footer(class='footer-modern')
      div(class='footer-inner')
        div(class='footer-grid')
          //─── Columna marca ──────────────────────────────────────────────
          div(class='footer-col footer-brand')
            img(src='@/assets/imgFerco/logo2.png' class='imgFot' @click='irHome()')
            p(v-if='settings.direccion' class='footer-text') {{settings.direccion}}
            div(style='width:280px;')
              v-skeleton-loader.mx-auto#ld2(v-if='policeSett' max-height='30' max-width='280' type='image')
            a(v-if='settings.whatsapp' class='footer-whatsapp' :href='"https://wa.me/"+settings.whatsapp' target='_blank')
              img(src='@/assets/imgFerco/whatsapp.png' style='height:24px;width:auto;object-fit:contain;')
              span {{settings.whatsapp}}
          //─── Columna categorías ─────────────────────────────────────────
          div(class='footer-col')
            h4(class='footer-title') Categorías
            p(class='footer-link' v-for='item in categorias' :key='item._id' @click='irProductos(item)') {{item.cat_des}}
            div(v-for='item in catArry' style='padding-bottom:8px;')
              v-skeleton-loader.mx-auto#ld2(v-if='policeCate' max-height='24' max-width='160' type='image')
          //─── Columna links ──────────────────────────────────────────────
          div(class='footer-col')
            h4(class='footer-title') Links de interés
            p(class='footer-link' @click='irContacto()') Contáctenos
            p(class='footer-link' @click='irAcerca()') Acerca de nosotros
            a(v-if='settings && settings.instagram' class='footer-link' style='display:block;text-decoration:none;' :href='"https://www.instagram.com/"+settings.instagram' target='_blank') @{{settings.instagram}}
        div(class='footer-bottom')
          span © {{ new Date().getFullYear() }} Emanuel Import. Todos los derechos reservados.

</template>
<script>
import { server, port, serverImg } from "@/services/environment";
import { EventBus } from '../Events.js'
import Api from "@/services/methods";
export default {
  data() {
    return {
      settings: {},
      mostrarP: false,
      policeCate: true,
      policeSett: true,
      catalogo: "",
      categorias: [],
      catArry: ['1', '2', '3', '4'],
      ruta: serverImg
    };
  },
  created() {
    if (this.$store.state.emanuelWeb && this.$store.state.emanuelWeb.co_cli) {
      this.mostrarP = true
    }
    this.initialize();
  },
  methods: {
    // verificar() {
    //   this.$nextTick(() => {
    //     $("#sobre").trigger("click");
    //   })
    //   return this.$route.name
    // },
    // ir() {
    //   this.$router.push({name: 'Home', params: { value: 'other' }})
    // },
    irHome() {
      this.$router.push('/')
    },
    irContacto() {
      this.$router.push('/contacto')
    },
    irAcerca() {
      this.$router.push('/acerca')
    },
    irProductos(item) {
      if (this.$route.name == "Productos") {
        EventBus.$emit('buscarCategoria', item)
      } else {
        this.$router.push({name: 'Productos', params: { categoria: item }})
      }
    },
    initialize(){
      this.policeSett = true
      Api.get('categoriaWeb/footer').then(res => {
        this.categorias = res.data
        if (res.data && res.data.length > 0) this.policeCate = false
      })
      Api.get('settings').then(res => {
        this.policeSett = false
        if (res.data && res.data[0]) {
          this.settings = res.data[0]
        }
      })
      // Api.get('settings/catalogo').then(res => {
      //   this.catalogo = res.data
      //   console.log(this.catalogo)
      // })
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/scss/footer.scss";
</style>
